import { Modal } from 'antd';
import styled from 'styled-components';

import { COLORS } from '../../../utils/theme/colors';

export const Container = styled.div`
  padding: 22px 26px 40px;
`;

export const PageHead = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;

  svg {
    position: relative;
    top: 2px;
    width: 21px;
    height: 21px;
  }

  .page-title {
    font-size: 19px;
    font-weight: 700;
    color: #1f2430;
  }
`;

export const Breadcrumb = styled.div`
  font-size: 12.5px;
  color: #8b8d97;
  margin-bottom: 18px;
  margin-left: 28px;

  b {
    color: #55565c;
    font-weight: 600;
  }
`;

export const FilterCard = styled.div`
  background: #fff;
  border: 1px solid #e7e7e9;
  border-radius: 8px;
  padding: 16px 18px;
  margin-bottom: 18px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-end;

  .field {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .field label {
    font-size: 11.5px;
    color: #8b8d97;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }

  .field.type-field {
    flex: 1;
    min-width: 220px;
  }

  .type-field .select,
  .type-field .list {
    margin-left: 0;
    width: 100%;
  }

  .type-field > div {
    height: 38px;
  }

  .type-field .select {
    box-shadow: none;
    border: 1px solid #e7e7e9;
    border-radius: 8px;
    justify-content: space-between;
    font-size: 13px;
  }

  .type-field .list_item {
    padding-left: 15px;
    padding-right: 15px;
  }

  .type-field .list {
    box-shadow: none;
    border: 1px solid #e7e7e9;
    font-size: 13px;
  }

  .ant-picker {
    border: 1px solid #e7e7e9;
    border-radius: 8px;
    background-color: #fff !important;
    height: 38px;
    width: 230px;
    box-shadow: none;
  }

  .ant-picker:hover {
    cursor: pointer;
    box-shadow: none;
  }

  .ant-picker .ant-picker-input > input {
    background-color: #fff !important;
  }

  .actions {
    display: flex;
    gap: 8px;
  }

  .actions button {
    height: 38px;
    min-width: 96px;
    padding: 0 16px;
    border-radius: 6px;
    font-size: 12.5px;
    font-weight: 600;
    cursor: pointer;
    border: 1px solid #b9bcc4;
    background: #fff;
    color: #40424a;
  }

  .actions button:hover {
    background: #f4f5f7;
  }

  .actions button.primary {
    background: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
    color: #fff;
  }

  .actions button.primary:hover {
    filter: brightness(0.92);
  }
`;

export const SummaryRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(200px, 1fr));
  gap: 14px;
  margin-bottom: 20px;
`;

export const SummaryCard = styled.div`
  background: #fff;
  border: 1px solid #e7e7e9;
  border-radius: 10px;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 6px;

  .label {
    font-size: 11px;
    letter-spacing: 0.4px;
    color: #8b8d97;
    font-weight: 700;
    text-transform: uppercase;
  }
  .value {
    font-size: 24px;
    font-weight: 700;
    color: ${({ theme }) => theme.primary};
  }
  .value.gray {
    color: #55565c;
    font-size: 19px;
  }
  .sub {
    font-size: 11.5px;
    color: #8b8d97;
    min-height: 15px;
  }

  .ant-skeleton {
    height: 33px;
  }

  .ant-skeleton .ant-skeleton-title {
    margin: 4px 0 0;
    height: 24px;
    border-radius: 6px;
  }
`;

export const TableCard = styled.div`
  background: #fff;
  border: 1px solid #e7e7e9;
  border-radius: 10px;
  overflow: hidden;

  .table-card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 18px;
    border-bottom: 1px solid #e7e7e9;
  }

  .table-card-head h3 {
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    color: #1f2430;
    display: flex;
    align-items: baseline;
    gap: 8px;
  }

  .table-card-head .count {
    font-size: 12px;
    font-weight: 500;
    color: #8b8d97;
  }

  .table-scroll {
    overflow-x: auto;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12.5px;
  }

  thead th {
    text-align: left;
    padding: 11px 18px;
    font-weight: 600;
    font-size: 11px;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    color: #8b8d97;
    background: #fbfbfc;
    border-bottom: 1px solid #e7e7e9;
    white-space: nowrap;
  }

  tbody td {
    padding: 12px 18px;
    border-bottom: 1px solid #f1f1f3;
    color: #40424a;
    vertical-align: middle;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  tbody tr:hover {
    background: #fbfbfc;
  }

  .change-name {
    font-weight: 600;
    color: #1f2430;
    white-space: nowrap;
  }

  .change-tenant {
    font-size: 11.5px;
    color: #8b8d97;
    margin-top: 2px;
  }

  .target-label {
    color: #1f2430;
    white-space: nowrap;
  }

  .value-old {
    color: #b03030;
  }

  .value-new {
    color: #3b7a26;
  }

  .value-dash {
    color: #8b8d97;
  }

  .timestamp {
    color: #8b8d97;
    white-space: nowrap;
  }

  .table-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 18px;
    border-top: 1px solid #e7e7e9;
    font-size: 12px;
    color: #8b8d97;
  }
`;

export const EmptyWrap = styled.div`
  padding: 40px 0;
`;

export const DetailButton = styled.button`
  background-color: ${COLORS.transparentDark};
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 12.5px;
  font-weight: 500;
  color: #444;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 200ms ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.hoveredDiv};
    color: ${({ theme }) => theme.primary};
  }
`;

export const DetailModal: any = styled(Modal)`
  /* Largura flexível: no mínimo 560px, cresce até a linha mais longa caber (um uuid, um item do
     snapshot) e só quebra linha quando passar da largura da tela. */
  &.ant-modal {
    min-width: 560px;
    max-width: calc(100vw - 32px);
  }

  .ant-modal-content {
    border-radius: 12px;
    overflow: hidden;
  }

  .ant-modal-header {
    border-bottom: none;
    padding-bottom: 4px;
  }

  .ant-modal-title {
    font-size: 20px;
    font-weight: normal;
    color: ${({ theme }) => theme.primary};
  }

  .ant-modal-close-x {
    color: ${({ theme }) => theme.primary};
  }

  .ant-modal-body {
    padding-top: 12px;
    padding-bottom: 24px;
  }

  .ant-modal-footer {
    border-top: none;
    padding: 8px 24px 24px;
  }
`;

export const MetadataList = styled.div`
  display: flex;
  flex-direction: column;
  /* Snapshot de configuração com muitos carregadores: rola dentro do modal, título fixo. */
  max-height: 70vh;
  overflow-y: auto;

  .entry {
    display: flex;
    align-items: baseline;
    gap: 16px;
    padding: 11px 0;
    border-bottom: 1px solid #f1f1f3;
  }

  .entry:last-child {
    border-bottom: none;
  }

  .entry-label {
    flex: 0 0 200px;
    font-size: 11.5px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: #8b8d97;
  }

  .entry-value {
    flex: 1;
    font-size: 13.5px;
    color: #1f2430;
    word-break: break-word;
    white-space: pre-wrap;
  }
`;
